import React, { useRef, createContext, useReducer } from 'react';

import useHasScopeTypes from 'hooks/useHasScopeType';
import Container from './Container';
import ProjectsTable from './components/ProjectsTable';
import typeReducer from './reducers/typeReducer';
import SelectDownloadType from './components/SelectDownloadType';

export const TypeReducerContext = createContext();
const initState = typeReducer();

const BulkDownload = () => {
  const { hasScopeType, loading } = useHasScopeTypes('VIEW_ALL_PROJECT');
  const reducer = useReducer(typeReducer, initState);
  const actionRef = useRef();
  return (
    <TypeReducerContext.Provider value={reducer}>
      <Container
        title="Bulk Download"
        loading={loading}
        content={<SelectDownloadType />}
      >
        <ProjectsTable canViewAll={hasScopeType} actionRef={actionRef} />
      </Container>
    </TypeReducerContext.Provider>
  );
};

export default BulkDownload;
